import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { getLiabilityGroups } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/liabilities/constants.ts';
import { LiabilityGroup } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/liabilities/LiabilityGroup.tsx';
import type { ILiabilitiesSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/liabilities/types.ts';
import { useDocumentGenerationOptions } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/hooks/useDocumentGenerationOptions.ts';
import {
  BorrowerType,
  FinancialStatementForm,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const LiabilitiesSection: React.FC<ILiabilitiesSectionProps> = ({ disabled }) => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const financialStatementForm = watch('financialStatementForm')?.value as
    FinancialStatementForm | undefined;
  const isLegalEntity = borrowerType === BorrowerType.LegalEntity;
  const { shortBankOptions, isBanksLoading } = useDocumentGenerationOptions();

  if (!isLegalEntity || !financialStatementForm) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        8. Розшифровка зобов’язань
      </Typography>
      {getLiabilityGroups(financialStatementForm).map((group) => (
        <LiabilityGroup
          key={group.name}
          {...group}
          disabled={disabled}
          creditorOptions={shortBankOptions}
          isBanksLoading={isBanksLoading}
        />
      ))}
    </Box>
  );
};
